var modules_2529eb59 = {"layout":"_9l7j6s","containerBgColor-primary":"_1jsuac6","containerBgColor-secondary":"_1tj7s9p","appBanner":"_1rloyji","storesBanner":"_1t4z52s","contactsBanner":"_1y5lg5j"};
import "../../../assets/Cq2t8MNo.css";

export { modules_2529eb59 as default };
//# sourceMappingURL=Footer.module.less.js.map
